(() => {
  const styleId = 'jazeel-growave-rtl';

  const keepLauncherIconUpright = () => {
    const host = document.querySelector('.gw-widget-placeholder-RC [data-order]');
    const root = host?.shadowRoot;

    if (!root || root.getElementById(styleId)) return false;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .gw-launcher--position-RC .gw-launcher__icon {
        transform: rotate(-90deg) !important;
      }
    `;
    root.append(style);
    return true;
  };

  if (keepLauncherIconUpright()) return;

  const observer = new MutationObserver(() => {
    if (keepLauncherIconUpright()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  const styleId = 'jazeel-wishlist-rtl';

  const moveWishlistToLeft = () => {
    // Only apply on RTL/Arabic pages
    if (document.documentElement.dir !== 'rtl') return;

    document
      .querySelectorAll('.gw-add-to-wishlist-product-card-placeholder')
      .forEach((placeholder) => {

        // Tell Growave the position is left
        placeholder.setAttribute('data-gw-widget-position', 'left');

        const root = placeholder.shadowRoot;
        if (!root || root.getElementById(styleId)) return;

        const style = document.createElement('style');
        style.id = styleId;

        style.textContent = `
          .gw-toggle-wishlist-product-card-button {
            right: auto !important;
            left: 8px !important;
          }
        `;

        root.appendChild(style);
      });
  };

  moveWishlistToLeft();

  const observer = new MutationObserver(() => {
    moveWishlistToLeft();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();